import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { PersonalInfoInitStepDeclaration } from "./Steps/PersonalInformationInitStep";

const personalInfoMainStartupFlow = new FlowDefinition("PersonalInformationFlow");

personalInfoMainStartupFlow.addStep(PersonalInfoInitStepDeclaration);

personalInfoMainStartupFlow.setStartStep("PersonalInformationInit_Step");

export const personalInfoStartupFlowDefinition = new StepDefinition({
    stepName: "PersonalInformationFlow",
    stepFlow: personalInfoMainStartupFlow,
    contextIsolation: false
})